import React, {useEffect} from 'react';
import styled from 'styled-components';
import { useLocation } from "react-router-dom";

import Topbar from './Topbar';
import Footer from './Footer';
// import Showcase from './Showcase';

// import DatabaseService from './../../services/DatabaseService';

// import {LAYOUT_SM, LAYOUT_XS } from '../../config';

const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
  width: 100vw;
  padding-top: 76px;
`;

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const Layout = ({ layout, children }) => {
  // const [horses, setHorses] = useState([]);

  return (
    <Wrapper>
      <ScrollToTop />
      <Topbar layout={layout} />
      {children}
      <Footer />
    </Wrapper>
  )
}

export default Layout
